import exportToWindowWithWarning from "./../helpers";
import KAMPYLE_ONSITE_SDK from "./KAMPYLE_ONSITE_SDK";
import KAMPYLE_COMMON from "./KAMPYLE_COMMON";
import KAMPYLE_ADOBE_ANALYTICS from "./../integrations/adobe-analytics";
import KAMPYLE_ANIMATION from "./KAMPYLE_ANIMATION";
import KAMPYLE_GA from "./../integrations/google-analytics";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_MESSAGE from "./KAMPYLE_MESSAGE";
import KAMPYLE_SCREEN_CAPTURE from "./KAMPYLE_SCREEN_CAPTURE";
import KAMPYLE_INTEGRATION from './KAMPYLE_INTEGRATION';
import MDIGITAL_FORM_STATE from "./MDIGITAL_FORM_STATE";
import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_UTILS from './KAMPYLE_UTILS';
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import MDIGITAL_ELEMENT_BUILDER from "./MDIGITAL_ELEMENT_BUILDER";
import MDIGITAL_EMBEDDED from "./MDIGITAL_EMBEDDED";
import KAMPYLE_TARGETING from "./KAMPYLE_TARGETING";
import KAMPYLE_THERMO_FISHER_TEALEAF from "./../integrations/thermo-fisher-tealeaf";
import KAMPYLE_VIEW from "./KAMPYLE_VIEW";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";
import CUSTOM_EVENTS from "./CUSTOM_EVENTS";
import CUSTOM_PARAMETERS from "./CUSTOM_PARAMETERS";
import MDIGITAL_DECIBEL from '../integrations/decibel';
import MDIGITAL_INIT from "./MDIGITAL_INIT";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import MDIGITAL_MODAL_DIALOGS from "./MDIGITAL_MODAL_DIALOGS";
import MDIGITAL_ON_PREM from "./MDIGITAL_ON_PREM";
import MDIGITAL_PROPERTY_MESSAGES from "./MDIGITAL_PROPERTY_MESSAGES";
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';
import MDIGITAL_PARTIAL_VIEW from './MDIGITAL_PARTIAL_VIEW';


function init() {
    window.KAMPYLE_ONSITE_SDK = KAMPYLE_ONSITE_SDK;

    // TODO: add in Phase 2 'isDebugMode' flag to url params or localStorage to enable access to global variables
    const urlParams = location.search.slice(1).split('&').reduce((acc, str) => {
        const [key, value] = str.split('=')
        return Object.assign(acc, {[key]: value})
    }, {});

    if(localStorage.isDebugMode === "true" || (!!urlParams.isDebugMode && KAMPYLE_UTILS.isFormInPreviewContext())) {
        window.KAMPYLE_DATA = KAMPYLE_DATA;
    }

    // TODO: add new flag to differentiate Preview mode to access these variables only for preview - Phase 2
    window.KAMPYLE_DATA = KAMPYLE_DATA;
    // TODO: remove notification after Phase 2
    // Integrations

    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isAdobeAEnabled) {
        exportToWindowWithWarning(KAMPYLE_ADOBE_ANALYTICS, 'KAMPYLE_ADOBE_ANALYTICS');
    }
    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isGAEnabled) {
        exportToWindowWithWarning(KAMPYLE_GA, 'KAMPYLE_GA');
    }
    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isThermoFisherTeaLeafEnabled){
        exportToWindowWithWarning(KAMPYLE_THERMO_FISHER_TEALEAF, 'KAMPYLE_THERMO_FISHER_TEALEAF_FUNC');
    }
    // KAMPYLE
    exportToWindowWithWarning(KAMPYLE_CONSTANT, "KAMPYLE_CONSTANT");
    exportToWindowWithWarning(KAMPYLE_UTILS, "KAMPYLE_UTILS");
    exportToWindowWithWarning(KAMPYLE_EVENT_DISPATCHER, "KAMPYLE_EVENT_DISPATCHER");
    exportToWindowWithWarning(KAMPYLE_FUNC, 'KAMPYLE_FUNC');
    exportToWindowWithWarning(KAMPYLE_ANIMATION, 'KAMPYLE_ANIMATION');
    exportToWindowWithWarning(KAMPYLE_COMMON, 'KAMPYLE_COMMON');
    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled){
      exportToWindowWithWarning(MDIGITAL_ANALYTICS, 'MDIGITAL_ANALYTICS');
    }
    exportToWindowWithWarning(KAMPYLE_INTEGRATION, 'KAMPYLE_INTEGRATION');
    exportToWindowWithWarning(KAMPYLE_MESSAGE, 'KAMPYLE_MESSAGE');
    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isScreenCaptureEnabled) {
        exportToWindowWithWarning(KAMPYLE_SCREEN_CAPTURE, 'KAMPYLE_SCREEN_CAPTURE');
    }
    exportToWindowWithWarning(KAMPYLE_TARGETING, 'KAMPYLE_TARGETING');
    exportToWindowWithWarning(KAMPYLE_VIEW, 'KAMPYLE_VIEW');
    // MDIGITAL
    exportToWindowWithWarning(MDIGITAL_ELEMENT_BUILDER, 'MDIGITAL_ELEMENT_BUILDER');
    exportToWindowWithWarning(MDIGITAL_FORM_STATE, 'FORM_STATE', true);
    exportToWindowWithWarning(MDIGITAL_CONFIGURATION, 'CONFIGURATION', true);
    exportToWindowWithWarning(CUSTOM_EVENTS, 'CUSTOM_EVENTS', true);
    exportToWindowWithWarning(CUSTOM_PARAMETERS, 'CUSTOM_PARAMETERS');
    exportToWindowWithWarning(MDIGITAL_EMBEDDED, 'EMBEDDED', true);
    exportToWindowWithWarning(MDIGITAL_INIT, 'INIT', true);
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.LOCALIZED_FORMS)) {
        exportToWindowWithWarning(MDIGITAL_LOCALIZATION, 'LOCALIZATION', true);
    }
    exportToWindowWithWarning(MDIGITAL_LOGGER, 'LOGGER', true);
    exportToWindowWithWarning(MDIGITAL_MODAL_DIALOGS, 'MODAL_DIALOGS', true);
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ON_PREM_HYBRID)) {
        exportToWindowWithWarning(MDIGITAL_ON_PREM, 'ON_PREM', true);
    }
    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isPropertyMessageEnabled) {
        exportToWindowWithWarning(MDIGITAL_PROPERTY_MESSAGES, 'PROPERTY_MESSAGES', true);
    }
    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDecibelEnabled) {
        exportToWindowWithWarning(MDIGITAL_DECIBEL, 'DECIBEL', true);
    }
    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isPartialViewEnabled) {
        exportToWindowWithWarning(MDIGITAL_PARTIAL_VIEW, 'PARTIAL_VIEW', true);
    }
}

export default {
    init: init
}
